module.exports = __webpack_public_path__ + "img/code.2cfb6a09.png";